import script from "./SearchTagInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTagInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchTagInput.vue?vue&type=style&index=0&id=574c51ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574c51ff"]])

export default __exports__